import type { Telemetry } from '../ports/telemetry.js';

/**
 * Console-backed Telemetry sink — the Step-0 adapter.
 *
 * Emits structured records to the console. Real metric/log backends attach later
 * behind the same {@link Telemetry} port without touching call sites.
 */
export function createConsoleTelemetry(): Telemetry {
  return {
    log(message, fields) {
      console.info('[telemetry] %s', message, fields ?? {});
    },
    metric(name, value, fields) {
      console.info('[telemetry:metric] %s=%d', name, value, fields ?? {});
    },
    error(error, fields) {
      console.error('[telemetry:error] %s: %s', error.kind, error.message, {
        cause: error.cause,
        ...fields,
      });
    },
  };
}
